/////////////////////////////////////////////////
//
// Manages the Live Recipe on Shop
//
////////////////////////////////////////////////////////////
class Recipe extends App.Entities.Recipe {
    constructor() {
        super();
    }
}
App.Interface.Recipe = new Recipe();